var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(this.durationToMinutes)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }